function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import form from '../config/base/form';
import field from '../config/base/field';
import validate from '../config/base/validate';
import { deepCopy } from '@form-create/utils/lib/deepextend';
import is, { hasProperty } from '@form-create/utils/lib/type';
import { lower } from '@form-create/utils/lib/tocase';
import ruleList from '../config/rule';
import draggable from 'vuedraggable';
import createMenu from '../config/menu';
import { upper } from '../utils/index';
import { designerForm } from '../config/viewForm';
import formCreate from '../config/viewForm';
import { approveHolidayTypeSelectApi } from '@/api/business.js';
export default {
  name: 'FcDesigner',
  components: {
    draggable: draggable,
    FormCreate: designerForm.$form(),
    viewForm: formCreate.$form()
  },
  props: ['menu', 'height', 'config', 'condition'],
  computed: {
    height_: function height_() {
      var h = this.height;
      if (!h) return '100%';
      return is.Number(h) ? "".concat(h, "px") : h;
    }
  },
  mounted: function mounted() {
    this.approveHolidayTypeSelect();
  },
  provide: function provide(_) {
    return {
      fcx: {
        active: null
      }
    };
  },
  data: function data() {
    var _this = this;
    var children = [];
    return {
      activeName: 'first',
      holidayRule: [],
      cacheProps: {},
      basicCacheProps: {},
      moveRule: null,
      addRule: null,
      added: null,
      activeTab: 'form',
      activeRule: null,
      children: children,
      menuList: this.menu || createMenu(),
      showBaseRule: false,
      visible: {
        preview: false
      },
      preview: {
        state: false,
        rule: [],
        option: {}
      },
      dragForm: {
        rule: this.makeDragRule(children),
        api: {}
      },
      typeList: ['leaveFrom', 'overtimeFrom', 'outFrom', 'refillFrom', 'tripFrom', 'contractPayment', 'contractRenewal', 'contractExpenditure', 'issueInvoice', 'voidedInvoice'],
      gropList: [],
      // validateLonelyGroup: false,
      form: {
        rule: form(),
        option: {
          form: {
            labelPosition: 'top',
            size: 'mini'
          },
          submitBtn: false
        },
        value: {
          form: {
            inline: false,
            hideRequiredAsterisk: false,
            labelPosition: 'top',
            size: 'medium',
            labelWidth: '125px'
          },
          submitBtn: false
        }
      },
      baseForm: {
        rule: field(),
        api: {},
        options: {
          form: {
            labelPosition: 'top',
            size: 'mini'
          },
          submitBtn: false,
          mounted: function mounted(fapi) {
            fapi.activeRule = _this.activeRule;
            fapi.setValue(fapi.options.formData || {});
          }
        }
      },
      validateForm: {
        rule: validate(),
        api: {},
        options: {
          form: {
            labelPosition: 'top',
            size: 'mini'
          },
          submitBtn: false,
          mounted: function mounted(fapi) {
            fapi.activeRule = _this.activeRule;
            fapi.setValue(fapi.options.formData || {});
          }
        }
      },
      propsForm: {
        rule: [],
        api: {},
        options: {
          form: {
            labelPosition: 'top',
            size: 'mini'
          },
          submitBtn: false,
          mounted: function mounted(fapi) {
            fapi.activeRule = _this.activeRule;
            fapi.setValue(fapi.options.formData || {});
          }
        }
      },
      basicForm: {
        rule: [],
        api: {},
        options: {
          form: {
            labelPosition: 'top',
            size: 'mini'
          },
          submitBtn: false,
          mounted: function mounted(fapi) {
            fapi.activeRule = _this.activeRule;
            fapi.setValue(fapi.options.formData || {});
          }
        }
      }
    };
  },
  watch: {
    'preview.state': function previewState(n) {
      var _this2 = this;
      if (!n) {
        this.$nextTick(function () {
          _this2.preview.rule = _this2.preview.option = null;
        });
      }
    }
  },
  methods: {
    approveHolidayTypeSelect: function approveHolidayTypeSelect() {
      var _this3 = this;
      approveHolidayTypeSelectApi().then(function (res) {
        _this3.holidayRule = res.data;
      });
    },
    addMenu: function addMenu(config) {
      var _this4 = this;
      if (!config.name || !config.list) return;
      var flag = true;
      this.menuList.forEach(function (v, i) {
        if (v.name === config.name) {
          _this4.$set(_this4.menuList, i, config);
          flag = false;
        }
      });
      if (flag) {
        this.menuList.push(config);
      }
    },
    removeMenu: function removeMenu(name) {
      var _this5 = this;
      ;
      _toConsumableArray(this.menuList).forEach(function (v, i) {
        if (v.name === name) {
          _this5.menuList.splice(i, 1);
        }
      });
    },
    setMenuItem: function setMenuItem(name, list) {
      this.menuList.forEach(function (v) {
        if (v.name === name) {
          v.list = list;
        }
      });
    },
    appendMenuItem: function appendMenuItem(name, item) {
      this.menuList.forEach(function (v) {
        if (v.name === name) {
          v.list.push(item);
        }
      });
    },
    removeMenuItem: function removeMenuItem(item) {
      this.menuList.forEach(function (v) {
        var idx;
        if (is.String(item)) {
          ;
          _toConsumableArray(v.list).forEach(function (menu, idx) {
            if (menu.name === item) {
              v.list.splice(idx, 1);
            }
          });
        } else {
          if ((idx = v.list.indexOf(item)) > -1) {
            v.list.splice(idx, 1);
          }
        }
      });
    },
    addComponent: function addComponent(data) {
      if (Array.isArray(data)) {
        data.forEach(function (v) {
          ruleList[v.name] = v;
        });
      } else {
        ruleList[data.name] = data;
      }
    },
    dragStart: function dragStart(children) {
      this.moveRule = children;
      this.added = false;
    },
    dragUnchoose: function dragUnchoose(children, evt) {
      this.addRule = {
        children: children,
        oldIndex: evt.oldIndex
      };
    },
    getParent: function getParent(rule) {
      var parent = rule.__fc__.parent.rule;
      var config = parent.config;
      if (config && config.config.inside) {
        rule = parent;
        parent = parent.__fc__.parent.rule;
      }
      return {
        root: parent,
        parent: rule
      };
    },
    makeDrag: function makeDrag(group, tag, children, on, subRule) {
      return {
        type: 'DragBox',
        wrap: {
          show: false
        },
        col: {
          show: false
        },
        inject: true,
        props: {
          rule: {
            props: {
              tag: 'el-col'
            },
            attrs: {
              group: group === true ? 'default' : group,
              ghostClass: 'ghost',
              animation: 150,
              handle: '._fc-drag-btn',
              emptyInsertThreshold: 0,
              direction: 'vertical'
            }
          },
          subRule: subRule || {
            props: {
              name: 'fade',
              tag: 'div'
            }
          },
          tag: tag
        },
        children: children,
        on: on
      };
    },
    clearDragRule: function clearDragRule() {
      this.gropList = [];
      this.setRule([]);
    },
    makeDragRule: function makeDragRule(children) {
      var _this6 = this;
      return [this.makeDrag(true, 'draggable', children, {
        add: function add(inject, evt) {
          return _this6.dragAdd(children, evt);
        },
        end: function end(inject, evt) {
          return _this6.dragEnd(children, evt);
        },
        start: function start(inject, evt) {
          return _this6.dragStart(children, evt);
        },
        unchoose: function unchoose(inject, evt) {
          return _this6.dragUnchoose(children, evt);
        }
      }, {
        props: {
          name: 'fade',
          tag: 'div'
        }
      })];
    },
    previewFc: function previewFc() {
      this.preview.state = true;
      this.preview.rule = this.getRule();
      this.preview.option = this.getOption();
    },
    getRule: function getRule() {
      var _this7 = this;
      var data = this.parseRule(deepCopy(this.dragForm.api.rule[0].children));
      data.forEach(function (value) {
        if (value.hasOwnProperty('children')) {
          value.children.forEach(function (item) {
            if (item.title === '假期类型') {
              _this7.$set(item, 'options', _this7.holidayRule);
            }
          });
        }
      });
      return data;
    },
    getJson: function getJson() {
      return formCreate.toJson(this.getRule());
    },
    getOption: function getOption() {
      var option = deepCopy(this.form.value);
      delete option.submitBtn;
      return option;
    },
    setRule: function setRule(rules) {
      var children = this.loadRule(is.String(rules) ? formCreate.parseJson(rules) : rules);
      this.children = children;
      this.clearActiveRule();
      this.dragForm.rule = this.makeDragRule(children);
    },
    clearActiveRule: function clearActiveRule(type) {
      if (this.typeList.indexOf(type) >= 0) {
        this.gropList = [];
      }
      this.activeRule = null;
      this.activeTab = 'form';
    },
    setOption: function setOption(option) {
      var _ = option;
      _.submitBtn = false;
      delete _.resetBtn;
      this.form.value = _;
    },
    loadRule: function loadRule(rules) {
      var _this8 = this;
      var loadRule = [];
      rules.forEach(function (rule) {
        if (is.String(rule)) {
          return loadRule.push(rule);
        }
        var config = ruleList[rule._fc_drag_tag] || ruleList[rule.type];
        var _children = rule.children;
        rule.children = [];
        if (rule.control) {
          rule._control = rule.control;
          delete rule.control;
        }
        if (config) {
          rule = _this8.makeRule(config, rule);
          if (_children) {
            var _children2;
            var children = rule.children[0].children;
            if (config.drag) {
              children = children[0].children;
            }
            (_children2 = children).push.apply(_children2, _toConsumableArray(config.loadChildren === false ? _children : _this8.loadRule(_children)));
          }
        } else if (_children) {
          rule.children = _this8.loadRule(_children);
        }
        loadRule.push(rule);
      });
      return loadRule;
    },
    parseRule: function parseRule(children) {
      var _this9 = this;
      return _toConsumableArray(children).reduce(function (initial, rule) {
        if (is.String(rule)) {
          initial.push(rule);
          return initial;
        } else if (rule.type === 'DragBox') {
          initial.push.apply(initial, _toConsumableArray(_this9.parseRule(rule.children)));
          return initial;
        } else if (rule.type === 'DragTool') {
          rule = rule.children[0];
          if (rule.type === 'DragBox') {
            initial.push.apply(initial, _toConsumableArray(_this9.parseRule(rule.children)));
            return initial;
          }
        }
        if (!rule) return initial;
        rule = _objectSpread({}, rule);
        if (rule.children.length) {
          rule.children = _this9.parseRule(rule.children);
        }
        delete rule._id;
        delete rule.originChildren;
        if (rule.config) {
          delete rule.config.config;
        }
        if (rule.effect) {
          delete rule.effect._fc;
          delete rule.effect._fc_tool;
        }
        if (rule._control) {
          rule.control = rule._control;
          delete rule._control;
        }
        Object.keys(rule).filter(function (k) {
          return Array.isArray(rule[k]) && rule[k].length === 0 || is.Object(rule[k]) && Object.keys(rule[k]).length === 0;
        }).forEach(function (k) {
          delete rule[k];
        });
        initial.push(rule);
        return initial;
      }, []);
    },
    baseChange: function baseChange(field, value, _, fapi) {
      if (this.activeRule && fapi[this.activeRule._id] === this.activeRule) {
        if (field == 'info') {
          this.activeRule.props.placeholder = value;
        } else {
          this.$set(this.activeRule, field, value);
        }
      }
    },
    propRemoveField: function propRemoveField(field, _, fapi) {
      if (this.activeRule && fapi[this.activeRule._id] === this.activeRule) {
        this.dragForm.api.sync(this.activeRule);
        if (field.indexOf('formCreate') === 0) {
          field = field.replace('formCreate', '');
          if (!field) return;
          field = lower(field);
          if (field.indexOf('effect') === 0 && field.indexOf('>') > -1) {
            this.$delete(this.activeRule.effect, field.split('>')[1]);
          } else if (field.indexOf('props') === 0 && field.indexOf('>') > -1) {
            this.$delete(this.activeRule.props, field.split('>')[1]);
          } else if (field === 'child') {
            this.$delete(this.activeRule.children, 0);
          } else if (field) {
            this.$set(this.activeRule, field, undefined);
          }
        } else {
          this.$delete(this.activeRule.props, field);
        }
      }
    },
    propChange: function propChange(field, value, _, fapi) {
      var _this10 = this;
      if (this.activeRule.children && this.activeRule.children.length > 1) {
        this.activeRule.children.forEach(function (item) {
          if (item.type == 'timeFrom') {
            _this10.$set(item.props, field, value);
          }
        });
      } else {
        if (this.activeRule && fapi[this.activeRule._id] === this.activeRule) {
          if (field.indexOf('formCreate') === 0) {
            field = field.replace('formCreate', '');
            if (!field) return;
            field = lower(field);
            if (field.indexOf('effect') === 0 && field.indexOf('>') > -1) {
              this.$set(this.activeRule.effect, field.split('>')[1], value);
            } else if (field.indexOf('props') === 0 && field.indexOf('>') > -1) {
              this.$set(this.activeRule.props, field.split('>')[1], value);
            } else if (field === 'child') {
              this.$set(this.activeRule.children, 0, value);
            } else {
              this.$set(this.activeRule, field, value);
            }
          } else {
            this.$set(this.activeRule.props, field, value);
          }
        }
      }
    },
    basicChange: function basicChange(field, value, _, fapi) {
      var _this11 = this;
      if (this.activeRule.children && this.activeRule.children.length > 1) {
        this.activeRule.children.forEach(function (item) {
          if (item.type == 'timeFrom') {
            _this11.$set(item.props, field, value);
          }
        });
      } else {
        if (this.activeRule && fapi[this.activeRule._id] === this.activeRule) {
          if (field.indexOf('formCreate') === 0) {
            field = field.replace('formCreate', '');
            if (!field) return;
            field = lower(field);
            if (field.indexOf('effect') === 0 && field.indexOf('>') > -1) {
              this.$set(this.activeRule.effect, field.split('>')[1], value);
            } else if (field.indexOf('props') === 0 && field.indexOf('>') > -1) {
              this.$set(this.activeRule.props, field.split('>')[1], value);
            } else if (field === 'child') {
              this.$set(this.activeRule.children, 0, value);
            } else {
              this.$set(this.activeRule, field, value);
            }
          } else {
            this.$set(this.activeRule.props, field, value);
          }
        }
      }
    },
    basicRemoveField: function basicRemoveField(field, _, fapi) {
      // 确保当前激活的规则存在，并且是当前表单API实例操作的目标
      if (this.activeRule && fapi[this.activeRule._id] === this.activeRule) {
        // 首先同步表单状态
        this.dragForm.api.sync(this.activeRule);

        // 基于字段名移除对应的属性
        if (field.indexOf('formCreate') === 0) {
          field = field.replace('formCreate', '');
          if (!field) return;
          field = field.toLowerCase();
          if (field.indexOf('effect') === 0 && field.indexOf('>') > -1) {
            this.$delete(this.activeRule.effect, field.split('>')[1]);
          } else if (field.indexOf('props') === 0 && field.indexOf('>') > -1) {
            this.$delete(this.activeRule.props, field.split('>')[1]);
          } else if (field === 'child') {
            this.$delete(this.activeRule.children, 0);
          } else if (field) {
            this.$set(this.activeRule, field, undefined);
          }
        } else {
          // 如果字段不是以 'formCreate' 开头，则直接从 activeRule 中移除
          this.$delete(this.activeRule, field);
        }
      }
    },
    validateChange: function validateChange(formData) {
      var _this12 = this;
      if (!this.activeRule || this.validateForm.api[this.activeRule._id] !== this.activeRule) return;
      this.activeRule.validate = formData.validate || [];
      this.dragForm.api.refreshValidate();
      this.dragForm.api.nextTick(function () {
        _this12.dragForm.api.clearValidateState(_this12.activeRule.field);
      });
    },
    toolActive: function toolActive(rule) {
      var _this13 = this;
      if (this.activeRule) {
        delete this.propsForm.api[this.activeRule._id];
        delete this.baseForm.api[this.activeRule._id];
        delete this.validateForm.api[this.activeRule._id];
        delete this.basicForm.api[this.activeRule._id];
      }
      this.activeRule = rule;
      this.$nextTick(function () {
        _this13.activeTab = 'props';
        _this13.$nextTick(function () {
          _this13.propsForm.api[_this13.activeRule._id] = _this13.activeRule;
          _this13.basicForm.api[_this13.activeRule._id] = _this13.activeRule;
          _this13.baseForm.api[_this13.activeRule._id] = _this13.activeRule;
          _this13.validateForm.api[_this13.activeRule._id] = _this13.activeRule;
        });
      });
      if (!this.cacheProps[rule._id]) {
        this.cacheProps[rule._id] = rule.config.config.props();
      }
      if (rule.config.config.basic()) {
        this.basicCacheProps[rule._id] = rule.config.config.basic();
      }
      this.propsForm.rule = this.cacheProps[rule._id];
      this.basicForm.rule = this.basicCacheProps[rule._id];
      var formData = _objectSpread(_objectSpread({}, rule.props), {}, {
        formCreateChild: rule.children[0]
      });
      Object.keys(rule).forEach(function (k) {
        if (['effect', 'config', 'payload', 'id', 'type'].indexOf(k) < 0) formData['formCreate' + upper(k)] = rule[k];
      });
      ['props', 'effect'].forEach(function (name) {
        rule[name] && Object.keys(rule[name]).forEach(function (k) {
          formData['formCreate' + upper(name) + '>' + k] = rule[name][k];
        });
      });
      this.propsForm.options.formData = formData;
      this.basicForm.options.formData = formData;
      this.showBaseRule = hasProperty(rule, 'field') && rule.input !== false;
      if (this.showBaseRule) {
        this.baseForm.options.formData = {
          field: rule.field,
          title: rule.title || '',
          info: rule.info,
          _control: rule._control
        };
        this.validateForm.options.formData = {
          validate: rule.validate ? _toConsumableArray(rule.validate) : []
        };
      }
    },
    dragAdd: function dragAdd(children, evt) {
      var newIndex = evt.newIndex;
      var menu = evt.item._underlying_vm_;
      if (!menu) {
        if (this.addRule) {
          var rule = this.addRule.children.splice(this.addRule.oldIndex, 1);
          children.splice(newIndex, 0, rule[0]);
        }
      } else {
        var _rule2 = this.makeRule(ruleList[menu.name]);
        children.splice(newIndex, 0, _rule2);
      }
      this.added = true;
    },
    dragEnd: function dragEnd(children, _ref) {
      var newIndex = _ref.newIndex,
        oldIndex = _ref.oldIndex;
      if (!this.added && !(this.moveRule === children && newIndex === oldIndex)) {
        var rule = this.moveRule.splice(oldIndex, 1);
        children.splice(newIndex, 0, rule[0]);
      }
      this.moveRule = null;
      this.addRule = null;
      this.added = false;
    },
    makeRule: function makeRule(config, _rule) {
      var _this14 = this;
      // 在所有拖拽项目里面找该config是否属于控件组下的数据
      var dataSources = this.menuList[0];
      if (this.menuList && dataSources && dataSources.group && dataSources.group.length !== 0) {
        // 如果是控件组下的数据
        if (dataSources.group.some(function (item) {
          return item === config;
        }) || dataSources.contract.some(function (item) {
          return item === config;
        })) {
          // 判断是否有其他控件组数据
          if (this.gropList.length === 0) {
            this.gropList.push(config);
          } else {
            this.$message.error('当前表单最多只能添加一个控件组');
            return;
          }
        }
      }
      var rule = _rule || config.rule();
      rule.config = {
        config: config
      };
      if (!rule.effect) rule.effect = {};
      rule.effect._fc = true;
      rule._fc_drag_tag = config.name;
      var drag;
      rule.originChildren = rule.children;
      if (config.drag) {
        var children = [];
        rule.children.push(drag = this.makeDrag(config.drag, rule.type, children, {
          end: function end(inject, evt) {
            return _this14.dragEnd(inject.self.children, evt);
          },
          add: function add(inject, evt) {
            return _this14.dragAdd(inject.self.children, evt);
          },
          start: function start(inject, evt) {
            return _this14.dragStart(inject.self.children, evt);
          },
          unchoose: function unchoose(inject, evt) {
            return _this14.dragUnchoose(inject.self.children, evt);
          }
        }));
        rule.originChildren = children;
      }
      if (config.children && !_rule) {
        var child = this.makeRule(ruleList[config.children]);
        (drag || rule).children.push(child);
      }
      if (config.inside) {
        rule.children = [{
          type: 'DragTool',
          props: {
            dragBtn: config.dragBtn !== false,
            children: config.children,
            type: rule.type
          },
          effect: {
            _fc_tool: true
          },
          inject: true,
          on: {
            delete: function _delete(_ref2) {
              var self = _ref2.self;
              var top = _this14.getParent(self);
              var field = top.parent.field;
              if (_this14.condition && _this14.condition.indexOf(field) > -1) {
                _this14.$message.error('该字段在流程中被使用');
                return;
              }
              _this14.getParent(self).parent.__fc__.rm();
              _this14.clearActiveRule(rule.type);
            },
            add: function add(_ref3) {
              var self = _ref3.self;
              var top = _this14.getParent(self);
              top.root.children.splice(top.root.children.indexOf(top.parent) + 1, 0, _this14.makeRule(top.parent.config.config));
            },
            addChild: function addChild(_ref4) {
              var self = _ref4.self;
              var top = _this14.getParent(self);
              var config = top.parent.config.config;
              var item = ruleList[config.children];
              if (!item) return;
              (!config.drag ? top.parent : top.parent.children[0]).children[0].children.push(_this14.makeRule(item));
            },
            copy: function copy(_ref5) {
              var self = _ref5.self;
              var top = _this14.getParent(self);
              top.root.children.splice(top.root.children.indexOf(top.parent) + 1, 0, formCreate.copyRule(top.parent));
            },
            active: function active(_ref6) {
              var self = _ref6.self;
              _this14.toolActive(_this14.getParent(self).parent);
            }
          },
          children: rule.children
        }];
        return rule;
      } else {
        return {
          type: 'DragTool',
          props: {
            dragBtn: config.dragBtn !== false,
            children: config.children,
            type: rule.type
          },
          effect: {
            _fc_tool: true
          },
          inject: true,
          on: {
            delete: function _delete(_ref7) {
              var self = _ref7.self;
              var field = self.children[0].field;
              if (_this14.condition && _this14.condition.indexOf(field) > -1) {
                _this14.$message.error('该字段在流程中被使用');
                return;
              }
              self.__fc__.rm();
              _this14.clearActiveRule(rule.type);
            },
            add: function add(_ref8) {
              var self = _ref8.self;
              var top = _this14.getParent(self);
              top.root.children.splice(top.root.children.indexOf(top.parent) + 1, 0, _this14.makeRule(self.children[0].config.config));
            },
            addChild: function addChild(_ref9) {
              var self = _ref9.self;
              var config = self.children[0].config.config;
              var item = ruleList[config.children];
              if (!item) return;
              (!config.drag ? self : self.children[0]).children[0].children.push(_this14.makeRule(item));
            },
            copy: function copy(_ref10) {
              var self = _ref10.self;
              var top = _this14.getParent(self);
              top.root.children.splice(top.root.children.indexOf(top.parent) + 1, 0, formCreate.copyRule(top.parent));
            },
            active: function active(_ref11) {
              var self = _ref11.self;
              _this14.toolActive(self.children[0]);
            }
          },
          children: [rule]
        };
      }
    }
  },
  created: function created() {
    document.body.ondrop = function (e) {
      e.preventDefault();
      e.stopPropagation();
    };
  }
};